const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = "/employee-services";

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
  let message = fallbackMessage;
  try {
    const data = await response.json();
    message = data?.message || data?.error || fallbackMessage;
  } catch (_) {
    try {
      const text = await response.text();
      message = text || fallbackMessage;
    } catch (_) {}
  }

  console.error(`API Error [${response.status}]: ${message}`);
  throw new Error(message);
};

export const getEmployeeServices = async (employeeId) => {
  const response = await fetch(`${BASE_URL}${API_URL}/${employeeId}/services`);

  if (!response.ok) {
    await handleError(response, "فشل في تحميل خدمات الموظف");
  }

  return await response.json();
};

export const assignEmployeeServices = async (employeeId, serviceIds, token) => {
  const response = await fetch(`${BASE_URL}${API_URL}/${employeeId}/services`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ serviceIds }),
  });

  if (!response.ok) {
    await handleError(response, "فشل في تعيين الخدمات للموظف");
  }

  return await response.json();
};

export const removeEmployeeService = async (employeeId, serviceId, token) => {
  const response = await fetch(`${BASE_URL}${API_URL}/${employeeId}/services/${serviceId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    await handleError(response, "فشل في إزالة الخدمة من الموظف");
  }

  return await response.json();
};

export const getEmployeesForService = async (serviceId) => {
  const response = await fetch(`${BASE_URL}${API_URL}/services/${serviceId}/employees`);

  if (!response.ok) {
    await handleError(response, "فشل في تحميل الموظفين المرتبطين بالخدمة");
  }

  return await response.json();
};
